// this will facilitate communication between parent and messenger
import visitor from  './visitor'
import store from  '../store/data'

const parseMessage = function (event) {
  var message;
  try{
    message = JSON.parse(event.data);
    //console.log(message);
  }
  catch(e){
    message = event;
  }

  switch (message.type) {
    case 'visitor:init':
      store.dispatch('getVisitor', message.payload)
      break
    case 'visitor:update':
      store.commit('UPDATE_VISITOR', message.payload)
      break
    case 'messenger:active':
      store.commit('SET_INACTIVE', message.payload)
      break
    case 'messenger:open':
      if (message.payload.firstVisit) {
        document.querySelector('#ding').play()
      }
      store.commit('SET_OPTION_OPEN', message.payload)
      break
    default:
      console.log(`"${message.type}" not found`)
  }
}

const Message = {
  install(Vue, options) {
    window.addEventListener('message', parseMessage, false)
  },
  send(data) {
    parent.postMessage(data, '*')
  }
}

export default Message



// WEBPACK FOOTER //
// ./src/services/message.js